module.exports = __webpack_public_path__ + "assets/50275ece3a20329bc5f0276b8de229ff.mp3";